import DOMPurify from 'isomorphic-dompurify';
import parse from 'html-react-parser';

export const parsePurify = (data) => {
    return parse(DOMPurify.sanitize(data));
};
